import { TrackerEvent } from '../interfaces/tracker-event';
import { Location } from 'history';

interface PageViewedProperties {
  '[Amplitude] Page Counter': number;
  '[Amplitude] Page Domain': string;
  '[Amplitude] Page Location': string;
  '[Amplitude] Page Path': string;
  '[Amplitude] Page Title': string;
  '[Amplitude] Page URL': string;
  referrer: string | undefined;
  referring_domain: string | undefined;
}

interface PageViewedEventInput {
  location: Location;
  previousLocation: Location | undefined;
}

let counter = 0;

export class PageViewedEvent implements TrackerEvent<PageViewedProperties> {
  public name = '[Amplitude] Page Viewed';
  public properties: PageViewedProperties;

  constructor(input: PageViewedEventInput) {
    const url = new URL(input.location.pathname, window.location.origin);
    url.search = input.location.search;

    if (!input.previousLocation) {
      this.properties = {
        '[Amplitude] Page Counter': counter++,
        '[Amplitude] Page Domain': url.hostname,
        '[Amplitude] Page Location': url.href,
        '[Amplitude] Page Path': url.pathname,
        '[Amplitude] Page Title': document.title,
        '[Amplitude] Page URL': url.href,
        referrer: undefined,
        referring_domain: undefined,
      };
    } else {
      const prevUrl = new URL(input.previousLocation.pathname, window.location.origin);
      prevUrl.search = input.previousLocation.search;

      this.properties = {
        '[Amplitude] Page Counter': counter++,
        '[Amplitude] Page Domain': url.hostname,
        '[Amplitude] Page Location': url.href,
        '[Amplitude] Page Path': url.pathname,
        '[Amplitude] Page Title': document.title,
        '[Amplitude] Page URL': url.href,
        referrer: prevUrl.href,
        referring_domain: prevUrl.hostname,
      };
    }
  }
}
